'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _charities = require('../../api/charities');

var _CharityResult = require('./CharityResult');

var _CharityResult2 = _interopRequireDefault(_CharityResult);

var _inputSearch = require('constructicon/input-search');

var _inputSearch2 = _interopRequireDefault(_inputSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharitySearch = function (_Component) {
  _inherits(CharitySearch, _Component);

  function CharitySearch(props) {
    _classCallCheck(this, CharitySearch);

    var _this = _possibleConstructorReturn(this, (CharitySearch.__proto__ || Object.getPrototypeOf(CharitySearch)).call(this, props));

    _this.handleQuery = _this.handleQuery.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);

    _this.state = {
      results: [],
      status: null,
      value: null
    };
    return _this;
  }

  _createClass(CharitySearch, [{
    key: 'handleQuery',
    value: function handleQuery(q) {
      var _this2 = this;

      var _props = this.props,
          campaign = _props.campaign,
          country = _props.country;


      Promise.resolve().then(function () {
        return _this2.setState({ status: 'fetching' });
      }).then(function () {
        return (0, _charities.searchCharities)({ campaign: campaign, country: country, q: q });
      }).then(function (results) {
        return results.map(_charities.deserializeCharity);
      }).then(function (results) {
        return _this2.setState({ results: results, status: 'fetched' });
      }).catch(function (error) {
        _this2.setState({ status: 'failed' });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect() {
      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.setState({ value: selected.name });

      if (selected.id) {
        this.props.onChange(selected);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          inputProps = _props2.inputProps,
          ResultComponent = _props2.ResultComponent;
      var _state = this.state,
          results = _state.results,
          status = _state.status,
          value = _state.value;


      return _react2.default.createElement(_inputSearch2.default, _extends({}, inputProps, {
        autoComplete: 'off',
        onChange: this.handleSelect,
        onSearch: this.handleQuery,
        ResultComponent: ResultComponent,
        results: results,
        status: status,
        value: value
      }));
    }
  }]);

  return CharitySearch;
}(_react.Component);

CharitySearch.propTypes = {
  /**
   * Only show charities in this country
   */
  country: _propTypes2.default.oneOf(['au', 'nz', 'uk', 'us', 'ie']),

  /**
   * Only show charities in this campaign
   */
  campaign: _propTypes2.default.string,

  /**
   * The props to be passed to the input search component
   */
  inputProps: _propTypes2.default.object,

  /**
   * The callback to call when a selection is made
   */
  onChange: _propTypes2.default.func,

  /**
   * The component to render the search results
   */
  ResultComponent: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

CharitySearch.defaultProps = {
  ResultComponent: _CharityResult2.default
};

exports.default = CharitySearch;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/charity-search/index.js
// module id = 1335
// module chunks = 0